module.exports = __webpack_public_path__ + "static/media/cheer_1.bda5182f.jpeg";